import type { MechtaIDUser } from '@mechta-dev/mechta-id-js'
import type { JwtPayload } from 'jwt-decode'
import { jwtDecode } from 'jwt-decode'
import { defineStore } from 'pinia'

interface IState {
  token: string
  passCode: string
  passCodeSubject: string
  subject: string
  oidcRoles: string[]
  permissions: string[]
  authError: string
}

interface IToken extends JwtPayload {
  roles?: string[]
  payload?: {
    eid?: string
    exp?: number
    roles?: string[]
    subdivision?: string
  }
}

export const useAuthStore = defineStore('auth', {
  state: (): IState => {
    return {
      token: '',
      passCode: '',
      passCodeSubject: '',
      subject: '',
      oidcRoles: [],
      permissions: [],
      authError: '',
    }
  },
  getters: {
    decodeToken(state): IToken | null {
      if (!state.token) return null

      try {
        return jwtDecode<IToken>(state.token)
      } catch {
        return null
      }
    },
    roles(): string[] | undefined {
      if (this.oidcRoles.length) return this.oidcRoles
      return this.decodeToken?.roles ?? this.decodeToken?.payload?.roles
    },
  },
  actions: {
    setSSOUser(user: MechtaIDUser) {
      if (this.passCodeSubject !== user.subject) {
        this.passCode = ''
      }
      this.passCodeSubject = user.subject
      this.subject = user.subject
      this.token = user.accessToken
      this.oidcRoles = [...user.roles]
      this.permissions = [...user.permissions]
      this.authError = ''
    },
    clearSSO() {
      this.token = ''
      this.subject = ''
      this.oidcRoles = []
      this.permissions = []
    },
    setPassCode(data: string) {
      this.passCode = data
      this.passCodeSubject = this.subject
    },
    setAuthError(message: string) {
      this.authError = message
    },
  },
  persist: {
    pick: ['passCode', 'passCodeSubject'],
  },
})
